import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[finderBgImage]',
    standalone: true
})
export class BgImageDirective implements AfterViewInit, OnChanges {
    private blockData: any;

    @Input()
    set finderBgImage(data: any) {
        this.blockData = data;
    }

    @Input() isMobile;
    @Input() bgTarget;

    constructor(
        private elementRef: ElementRef,
    ) {}

    ngAfterViewInit() {
        this.setBgImage();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('isMobile' in changes) {
            // If this is the first change don't bother
            if (changes.isMobile.firstChange) {
                return;
            }

            // If the current value is different, set the bg image
            if (changes.isMobile.currentValue !== changes.isMobile.previousValue) {
                this.setBgImage();
            }
        }
    }

    private setBgImage() {
        // Check that we have a bg image in the data
        const bgImage = this.blockData?.background;
        if (!bgImage) {
            return;
        }

        const target = this.bgTarget || this.blockData.bgTarget;

        // Set the bg image on the element
        const el = target !== 'block-element' ?
            this.elementRef.nativeElement :
            this.elementRef.nativeElement.querySelector('.block-element');

        // Handle element class cleanup if necessary
        if (target === 'block-element') {
            this.elementRef.nativeElement.classList.remove('background-image');
            el.classList.add('background-image');
        }

        const img = bgImage
            .map((bg) =>  this.isMobile ? bg.mobile : bg.desktop)
            .filter(bg => bg.trim() !== '')  // Removes empty strings (falsy values)
            .join(', ');


        // Set default CSS vars for block layout renderer
        let cssProperties = {
            img: '--block-layout-renderer-background',
            pos: '--block-layout-renderer-background-position',
            size: '--block-layout-renderer-background-size',
            repeat: '--block-layout-renderer-background-repeat',
        };

        // Handle target override for campaign content header
        if (target === 'campaign-content-top') {
            cssProperties = {
                img: '--campaign-content-top-section-bg',
                pos: '--campaign-content-top-section-bg-position',
                size: '--campaign-content-top-section-bg-size',
                repeat: '--campaign-content-top-section-bg-repeat',
            };
        }

        // Background image
        el.style.setProperty(cssProperties.img, img);

        // Position
        let position = this.blockData.bgPosition || 'top left';
        if (this.isMobile) {
            position = this.blockData.bgPositionMobile || position;
        }
        el.style.setProperty(cssProperties.pos, position);

        // Size
        let size = this.blockData.bgSize || 'auto';
        if (this.isMobile) {
            size = this.blockData.bgSizeMobile ?? size;
        }
        el.style.setProperty(cssProperties.size, size);

        // Repeat
        let repeat = this.blockData.bgRepeat || 'no-repeat';
        if (this.isMobile) {
            repeat = this.blockData.bgRepeatMobile ?? repeat;
        }
        el.style.setProperty(cssProperties.repeat, repeat);
    }
}
